// This file will be deleted once all the calculators are configBuilder free
// to be deleted

import React from 'react';

import { Box, CenteredContainer, Tiles, Text } from '@nerdwallet/currency';

import ToolLinkCard from './tool-link-card';
import {
  ToolLinkCard as ToolLinkCardType,
  Data,
  CalculatorType,
  AnalyticsConfig,
} from './types';

interface ToolLinkCardsProps {
  /**
   * Tool link Header.
   */
  header?: string;
  /**
   * (Analytics) Impression Tracking Name
   */
  impressionTrackingName?: string;
  /**
   * Analytics Configuration Object.
   */
  analyticsConfig?: AnalyticsConfig;
  /**
   * The place where we're calling this tool link.
   */
  calculatorType?: CalculatorType;
  /**
   * Cards Collection.
   */
  cards: ToolLinkCardType[];
  /**
   * Data object provided by redux store
   */
  data?: Data;
}

const ToolLinkCards: React.FC<ToolLinkCardsProps> = ({
  header,
  impressionTrackingName,
  analyticsConfig,
  calculatorType,
  cards,
  data = {},
}: ToolLinkCardsProps) => {
  return (
    <Box paddingY="4" backgroundColor="yellow-lighter">
      <CenteredContainer>
        <Box paddingBottom="3-half">
          <Text size="large" align="left" bold>
            {header}
          </Text>
        </Box>
        <Tiles columns={{ mobile: 1, desktop: 4 }}>
          {cards?.map((card, index) => (
            <ToolLinkCard
              key={`tool_link_card_${index}`}
              card={card}
              cardIndex={index}
              impressionTrackingName={impressionTrackingName}
              analyticsConfig={analyticsConfig}
              calculatorType={calculatorType}
              data={data}
            />
          ))}
        </Tiles>
      </CenteredContainer>
    </Box>
  );
};

ToolLinkCards.displayName = 'ToolLinkCards';

export default ToolLinkCards;
